<script>
import Tag from './Tag'
import {Graylog} from '../graylog'
import tinyDebounce from './tinyDebounce'
import SelectedValue from './SelectedValue'

export default {
  name: 'GroupedDurations',

  components: {
    SelectedValue
  },

  props: {
    searchParams: Object,
    searchQuery: String,
    durationField: String,
    chartTitle: String,
    filterKey: String,
    filterValues: Array,

    aggregation: {
      default: 'total'
    }
  },

  data() {
    return {
      isLoading: false,
      lineChart: {
        data: [],
        title: this.chartTitle,
        height: '650px',
        library: {
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItem, data) => {
                let item = data.datasets[tooltipItem.datasetIndex]
                let tag = Tag.find(this.filterKey, item.label)
                if (tag) {
                  return tag.label
                }

                return item.label
              }
            }
          }
        }
      },
      throttledSearch: null,
      queue: [],
      shouldCancel: false,
      selectedValue: null
    }
  },

  watch: {
    filterKey: {
      immediate: true,
      handler() { this.performSearch() }
    },
    filterValues: {
      immediate: true,
      handler() { this.performSearch() }
    }
  },

  methods: {

    applyOnClickEvent() {
      if (!this.$refs.lineChart.chart) { return }
      this.$refs.lineChart.chart.chart.canvas.onclick = (ev) => {
        let chart = this.$refs.lineChart.chart.chart
        var element = chart.getElementAtEvent(ev)[0];

        if (element) {
          this.selectedValue = chart.data.datasets[element._datasetIndex].label
        } else {
          this.selectedValue = null
        }
      };
    },

    performSearch() {
      if (!this.throttledSearch) {
        this.throttledSearch = tinyDebounce(()=>{
          this._performSearch()
        }, 500)
      }

      if (this.isLoading) {
        this.shouldCancel = true
      }
      this.$nextTick(()=>{
        this.throttledSearch()
      })
    },

    _performSearch() {
      this.isLoading = true
      this.lineChart.data = []
      this.queue = this.filterValues.slice()

      this.workOnQueue()
    },

    workOnQueue() {
      if (this.shouldCancel || this.queue.length == 0) {
        this.shouldCancel = false
        this.isLoading = false
        return
      }

      let currentItem = this.queue.pop()
      let query = `${this.searchQuery} AND ${this.filterKey}:"${currentItem}"`

      Graylog.getFieldHistogramm(this.durationField, query, {
        range: this.searchParams.range,
        interval: this.searchParams.interval
      }).then(response => {
        console.log('aggregation', this.aggregation)
        this.lineChart.data.push(
          { name: currentItem, data: Graylog.toTimeline(response.data.results, this.aggregation) }
        )
        this.$nextTick(()=>{
          this.applyOnClickEvent()
          this.workOnQueue()
        })
      })
    }
  }

}
</script>

<template>
  <div>
    <div>
      <span v-if="isLoading">Loading: {{ filterValues.length - queue.length }} / {{ filterValues.length }}</span>

      <SelectedValue
        v-if="selectedValue"
        :filterKey="filterKey"
        :value="selectedValue"
      ></SelectedValue>
    </div>

    <line-chart
      ref="lineChart"
      :data="lineChart.data"
      :ytitle="lineChart.title"
      :height="lineChart.height"
      :library="lineChart.library"
      :curve="false"
      :legend="false"
    ></line-chart>
  </div>
</template>

<style>

</style>
